let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gKZAD")).then(() => parcelRequire('9CIPb'));